<div class="rounded-2xl border border-gray-100 bg-white p-6 filters-shadow">
  <div class="flex flex-col gap-6">
    <div class="grid grid-cols-1 gap-4 md:grid-cols-4">
      <div class="w-full md:col-span-2">
        <app-pharmacy-auto-complete
          variant="default"
          [label]="isArabic() ? 'الصيدلية' : 'Pharmacy'"
          [placeholder]="isArabic() ? 'ابحث عن الصيدلية' : 'Search pharmacy'"
          [noResultsText]="isArabic() ? 'لا توجد صيدليات' : 'No pharmacies found'"
          [clear]="pharmacyClear()"
          (itemSelected)="onPharmacySelected($event)" />
      </div>

      <div class="w-full">
        <app-filter-item-search
          [label]="isArabic() ? 'رقم الطلب' : 'Order ID'"
          [placeholder]="isArabic() ? 'ادخل رقم الطلب' : 'Enter Order ID'"
          [searchTerm]="orderId()"
          (searchTermChange)="onOrderIdChange($event)" />
        @if (orderIdInvalid()) {
          <p class="mt-1 text-right text-[12px] text-red-500">
            {{ isArabic() ? "يجب أن يحتوي رقم الطلب على أرقام فقط." : "Order ID must contain numbers only." }}
          </p>
        }
      </div>

      <div class="w-full">
        <app-filter-multi-select
          [label]="{ titleAr: 'الحالة', titleEn: 'Status' }"
          [items]="statusOptions()"
          [placeholder]="{ titleAr: 'حدد الحالة', titleEn: 'Select Status' }"
          [(selectedIds)]="statusIds"
          [showDropdown]="showStatusDropdown()"
          (toggleDropdown)="toggleStatusDropdown()"
          (selectionChange)="onStatusChange($event)" />
      </div>
    </div>

    <div class="grid grid-cols-1 gap-4 md:grid-cols-4">
      <div class="w-full">
        <app-filter-date-component
          [label]="isArabic() ? 'تاريخ الإنشاء من' : 'Created Date From'"
          [(value)]="createdOnFrom"
          [isInvalid]="dateInvalid() || futureDateInvalid()" />
      </div>

      <div class="w-full">
        <app-filter-date-component
          [label]="isArabic() ? 'تاريخ الإنشاء إلى' : 'Created Date To'"
          [(value)]="createdOnTo"
          [isInvalid]="dateInvalid() || futureDateInvalid()" />
      </div>

      <div class="w-full">
        <app-creator-auto-complete
          [label]="isArabic() ? 'تم الإنشاء بواسطة' : 'Created By'"
          [placeholder]="isArabic() ? 'ابحث عن المستخدم' : 'Search user'"
          [noResultsText]="isArabic() ? 'لا يوجد مستخدمين' : 'No users found'"
          [clear]="creatorClear()"
          (itemSelected)="onCreatorSelected($event)" />
      </div>

      <div class="hidden md:block"></div>
    </div>

    @if (dateErrorMsg()) {
      <p class="mt-[-10px] text-right text-[13px] text-red-500">{{ dateErrorMsg() }}</p>
    }

    <hr class="mt-2 border-gray-200" />

    <div class="flex flex-col-reverse items-start justify-between gap-4 md:flex-row md:items-center">
      <app-filter-sorting-component
        [(orderBy)]="orderBy"
        [orderDir]="orderDir()"
        [sortOptions]="sortOptions()"
        (toggleOrder)="toggleSortOrder()" />

      <div class="flex items-center gap-3">
        <button
          type="button"
          (click)="onReset()"
          class="borderTabsColor textTabsColor hover-bg-primary-10 cursor-pointer rounded-[8px] border bg-white px-8 py-2.5 text-[14px] font-bold shadow-sm transition-colors"
          i18n="@@resetFilterBtn">
          Clear
        </button>

        <button
          type="button"
          (click)="onApply()"
          [disabled]="!isFormValid()"
          class="bgTabsColor cursor-pointer rounded-[8px] px-8 py-2.5 text-[14px] font-bold text-white shadow-sm transition-colors disabled:cursor-not-allowed disabled:opacity-50"
          i18n="@@applyBtn">
          تطبيق
        </button>
      </div>
    </div>
  </div>
</div>
